var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head-inner"},[_c('div',[_c('div',[_vm._v("解决方案池")]),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v("提供一站式解决方式")])]),_c('div',{staticStyle:{"padding-top":"3px"}},[_c('img',{staticStyle:{"width":"520px","height":"296px"},attrs:{"src":require("../assets/images/solutionHead.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }